import { ImageSourcePropType } from 'react-native';
import { RobotBluetoothConnection } from './bluetooth/types';
import { RobotWebsocketConnection } from './websockets/types';

export type RobotTypeData = {
  id: number;
  displayName: string;
  image: ImageSourcePropType;
};

export type RobotTypes = 'aly_v1' | 'indi_v0';
export const ROBOT_TYPE_DATA: { [key in RobotTypes]: RobotTypeData } = {
  aly_v1: {
    id: 0x10,
    displayName: 'Hey Aly v1',
    image: require('../../../assets/robots/avatar/aly_v1.png'),
  },
  indi_v0: {
    id: 0x11,
    displayName: 'Hey Indi v0',
    image: require('../../../assets/robots/avatar/indi_v0.png'),
  },
} as const;

export type RobotDevice = {
  id: string;
  name: string;
  type: RobotTypes;

  websocketConnection?: RobotWebsocketConnection;

  bluetoothConnection?: RobotBluetoothConnection;
};

export type RobotConnectionStatus =
  | 'disconnected'
  | 'connecting'
  | 'connected'
  | 'disconnecting';
